<template>
  <div>
    <div class="landNavbar" id="fixed">
      <!-- brand design -->
      <div class="flexNav" id="landingLogo">
        <router-link
          :to="{
            name: 'Landingpage',
          }"
          class="flexLogo"
        >
          <img
            src="@/assets/landingLogo.svg"
            width="237"
            height="49"
            alt="main page logo"
          />
        </router-link>
      </div>

      <!-- profile design -->
      <div class="flexNav" id="navigation">
        <a class="landingButton" href="#contact">Contact Us</a>
        <!--:to="{
                name: 'Contact',
            }"-->
        <router-link
          class="landingButton"
          :to="{
            name: 'EmailLandingPage',
          }"
          >Schools</router-link
        >
        <router-link
          class="landingButton"
          :to="{
            name: 'Login',
          }"
          >Login</router-link
        >

        <router-link
          class="landingButton"
          :to="{
            name: 'Signup',
          }"
          >Sign up</router-link
        >
        <div class="hamburgerMenu">
          <input id="hamburgerBox" type="checkbox" />

          <span class="hamburgerLayer" id="firstLayer"></span>
          <span class="hamburgerLayer" id="secondLayer"></span>
          <span class="hamburgerLayer" id="thirdLayer"></span>

          <ul id="smallMenu">
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'EmailLandingPage',
              }"
              >Schools</router-link
            >
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Login',
              }"
              >Login</router-link
            >

            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Signup',
              }"
              >Sign up</router-link
            >

            <div id="contact" class="navbarBottom">
              <div class="totalContact contactLeft">
                <a
                  href="https://apps.apple.com/ca/app/courselnk/id1545799969"
                  class="appstore"
                  target="_blank"
                ></a>
                <a
                  href="https://facebook.com/courselnk"
                  class="facebook"
                  target="_blank"
                ></a>

                <a
                  href="https://instagram.com/courselnk"
                  class="instagram"
                  target="_blank"
                ></a>

                <a
                  href="https://linkedin.com/company/71220107"
                  class="linkedin"
                  target="_blank"
                ></a>
                <a
                  href="mailto:support@courselnk.com"
                  class="email"
                  target="_blank"
                ></a>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="!notAccepted" class="fixedPortal accessed">
      <div id="userStats">
        <div class="userBox">
          <p class="boldTitle">{{ ambassadorName }}</p>
          <p class="subTitle">email: {{ ambassadorEmail }}</p>
          <p class="subTitle">code: coming soon!</p>
          <p class="subTitle">link: coming soon!</p>
          <div class="statColumnBig">
            <p>
              This is your new portal! You'll soon be able to use it once we've
              helped you set it up with your CourseLnk account
            </p>
          </div>
        </div>
        <div class="userStatBox">
          <div class="statRow" style="margin-left: 5%;">
            <div class="statColumm" @click="changeToUser()">
              <img class="icon" src="@/assets/portalGroup.svg" />
              <div class="innerRow">
                <div class="innerRowInfo">
                  <img class="smallIcon" src="@/assets/portalTotal.png" />
                </div>
                <div class="innerRowInfo">
                  <p>0</p>
                </div>
                <div class="innerRowInfo">
                  <img class="smallIcon" src="@/assets/portalWeekly.png" />
                </div>
                <div class="innerRowInfo">
                  <p>0</p>
                </div>
              </div>
              <div class="additionalInfo">
                <p>0 total users</p>
                <p>0 this week</p>
              </div>
              <span
                class="underline"
                :class="{
                  chatShift: isChat,
                  userShift: isUser,
                  linkShift: isLink,
                }"
              ></span>
            </div>
            <div class="statColumm" @click="changeToChat()">
              <img class="icon" src="@/assets/portalChats.svg" />
              <div class="innerRow">
                <div class="innerRowInfo">
                  <img class="smallIcon" src="@/assets/portalTotal.png" />
                </div>
                <div class="innerRowInfo">
                  <p>0</p>
                </div>
                <div class="innerRowInfo">
                  <img class="smallIcon" src="@/assets/portalWeekly.png" />
                </div>
                <div class="innerRowInfo">
                  <p>0</p>
                </div>
              </div>
              <div class="additionalInfo">
                <p>0 total chats</p>
                <p>0 this week</p>
              </div>
            </div>
            <div class="statColumm" @click="changeToLink()">
              <img class="icon" src="@/assets/portalFriends.svg" />
              <div class="innerRow">
                <div class="innerRowInfo">
                  <img class="smallIcon" src="@/assets/portalTotal.png" />
                </div>
                <div class="innerRowInfo">
                  <p>0</p>
                </div>
                <div class="innerRowInfo">
                  <img class="smallIcon" src="@/assets/portalWeekly.png" />
                </div>
                <div class="innerRowInfo">
                  <p>0</p>
                </div>
              </div>
              <div class="additionalInfo">
                <p>0 total links</p>
                <p>0 this week</p>
              </div>
            </div>
          </div>
          <div v-if="isUser" id="graph">
            <p>user graph coming soon...</p>
          </div>
          <div v-if="isChat" id="graph">
            <p>chat graph coming soon...</p>
          </div>
          <div v-if="isLink" id="graph">
            <p>link graph coming soon...</p>
          </div>
        </div>
      </div>
      <div id="userProgress">
        <div class="greyArea">
          <div @click="changeProgressView(0)" class="circle green">
            <p class="circleText">Welcome!</p>
            <div class="hoverCircle"></div>
          </div>
          <div
            @click="changeProgressView(1)"
            class="circle"
            style="margin-left: 5%"
          >
            <p class="circleText">Rookie</p>
            <p class="circleNum">10 users</p>
            <div class="hoverCircle"></div>
          </div>
          <div
            @click="changeProgressView(2)"
            class="circle"
            style="margin-left: 10%"
          >
            <p class="circleText">Junior</p>
            <p class="circleNum">40 users</p>
            <div class="hoverCircle"></div>
          </div>
          <div
            @click="changeProgressView(3)"
            class="circle"
            style="margin-left: 13%"
          >
            <p class="circleText">Senior</p>
            <p class="circleNum">75 users</p>
            <div class="hoverCircle"></div>
          </div>
          <div
            @click="changeProgressView(4)"
            class="circle"
            style="margin-left: 20%"
          >
            <p class="circleText">Master</p>
            <p class="circleNum">150 users</p>
            <div class="hoverCircle"></div>
          </div>
          <div
            @click="changeProgressView(5)"
            class="circle"
            style="margin-left: 20%"
          >
            <p class="circleText">Godlike</p>
            <p class="circleNum">250 users</p>
            <div class="hoverCircle"></div>
          </div>
        </div>
        <div class="additionalProgress">
          <div>
            <p class="greenBold">Welcome to the team!</p>
            <p>
              With your new portal, you can now track your progress, see how
              many students you've helped, and how many conversations you've
              started! Make sure to save the url of this page as it is the only
              way to access your ambassador portal. Good luck with your efforts!
            </p>
          </div>
          <!--div v-if="currentPV == 1">
            <p class="greenBold">Rookie Ambassador</p>
            <p>
              With your new portal, you can now track your progress, see how
              many students you've helped, and how many conversations you've
              started! Good luck with your efforts!
            </p>
          </div>
          <div v-if="currentPV == 2">
            <p class="greenBold">Junior Ambassador</p>
            <p>
              With your new portal, you can now track your progress, see how
              many students you've helped, and how many conversations you've
              started! Good luck with your efforts!
            </p>
          </div>
          <div v-if="currentPV == 3">
            <p class="greenBold">Senior Ambassador</p>
            <p>
              With your new portal, you can now track your progress, see how
              many students you've helped, and how many conversations you've
              started! Good luck with your efforts!
            </p>
          </div>
          <div v-if="currentPV == 4">
            <p class="greenBold">Master Ambassador</p>
            <p>
              With your new portal, you can now track your progress, see how
              many students you've helped, and how many conversations you've
              started! Good luck with your efforts!
            </p>
          </div>
          <div v-if="currentPV == 5">
            <p class="greenBold">Godlike Ambassador</p>
            <p>
              With your new portal, you can now track your progress, see how
              many students you've helped, and how many conversations you've
              started! Good luck with your efforts!
            </p>
          </div-->
        </div>
      </div>
    </div>

    <div v-if="noSocial" class="fixedPortal nonAccessed">
      <p class="boldTitle text">Social Media</p>
      <p class="text">
        Representing Yourself and Ambassadors in the Community:
      </p>
      <p class="text">
        Congratulations on becoming a CourseLnk ambassador! It’s a competitive
        program, and we’re so happy to have you join the team. With that said,
        we have a few guidelines around how we represent ourselves and the
        program across social media, and throughout the community.
      </p>
      <p class="text">
        1. If you want to represent your Ambassador status in social media bios,
        simply use the words CourseLnk Ambassador.
      </p>
      <p class="text">
        2. Don’t be a troll. Having an opinion is totally fine but try to make
        sure your comments are constructive and useful, not mean or negative.
      </p>
      <p class="text">
        3. Remember that anything you post can’t be taken back, so think about
        it before you hit that POST button. People screenshot everything these
        days. If you don’t want someone to see it, don’t post it.
      </p>
      <p class="text">
        4. It should be clear that you’re not a CourseLnk employee, and when you
        express an opinion on social media, make it clear that it does not
        represent CourseLnk by saying so in the post description.
      </p>
      <p class="text">
        5. You embody the best parts of our community. Your conduct and behavior
        should represent the CourseLnk Ambassador program in a positive manner,
        even outside of it.
      </p>
      <p class="text">
        6. You should never take or share pictures of the chats you have with
        other students, fellow Ambassadors, or CourseLnk employees.
      </p>
      <p class="text">
        7. If you’re unsure if what you’re about to post is appropriate, pause
        and ask one of the CourseLnk employees before posting it.
      </p>
      <p class="text">
        8. We should hold each other accountable for our conduct. If you see
        someone representing the program in a poor manner, let us know.
      </p>
      <div class="text">
        <input type="checkbox" v-model="userSocialCheckBox" />
        <label for="checkbox" class="checkBoxText"
          >I have read and agree to follow these guidelines when I post about
          CourseLnk*</label
        >
        <br />
        <input type="checkbox" v-model="ourSocialCheckBox" />
        <label for="checkbox" class="checkBoxText"
          >I agree to my image being used for promotional materials
          (optional)</label
        >
        <div v-if="showConditionError" style="margin-top: 10px; color: red">
          You need to accept to follow our social media guidelines before
          continuing.
        </div>
      </div>
      <div class="fixedButton" @click="acceptSocial()">Continue</div>
    </div>

    <div v-if="notAccepted" class="fixedPortal nonAccessed">
      <p class="boldTitle text">Code of Conduct</p>
      <p class="text">
        CourseLnk Ambassadors are an integral part of the CourseLnk community.
        Our Ambassadors are a vibrant group of outgoing students who are
        passionate about bringing the value of CourseLnk to as many peers as
        possible. Just like every community, there are rules to make it a safe,
        fun, and engaging place. Creating a respectful and engaging community is
        every CourseLnk Ambassador’s responsibility. Whether helping other
        students, participating in the CourseLnk chats, the Ambassador social
        media channels, or elsewhere online, CourseLnk Ambassadors are expected
        to act in a respectable manner.
      </p>
      <p class="text">
        In addition to our CourseLnk Ambassador Handbook and Social Media
        Policy, this Code of Conduct applies to all Ambassadors when serving as
        a CourseLnk Ambassador, engaging in any capacity with any CourseLnk
        program, or communicating in any capacity about CourseLnk. Violating
        this Code of Conduct may lead to your suspension or removal from the
        CourseLnk Ambassador Program.
      </p>
      <p class="text">
        To protect the integrity of the CourseLnk Ambassador Program (“Program”)
        and the larger CourseLnk community, CourseLnk reserves the right to
        suspend or remove any Ambassador from the Program if CourseLnk
        determines, in its sole discretion, that the Ambassador has engaged in
        any conduct that is inappropriate, harmful, or otherwise in violation of
        CourseLnk’s Code of Conduct, Social Media Policy, or any other
        applicable policy or agreement. You are free to request reconsideration
        regarding your suspension, but we are not required to provide a reason
        for our decision.
      </p>
      <p class="text">
        Generally, instances of inappropriate conduct or language, may result in
        suspension from the Program and forfeiture of earned rewards. CouresLnk,
        in its sole discretion, will determine the length of any suspension or
        restriction on access to the Program. Further, you may be subject to
        removal from the Program for more severe violations of CourseLnk’s Code
        of Conduct, Social Media Policy, or any other applicable policy or
        agreement.
      </p>
      <p class="text">
        We may reconsider an Ambassador’s removal from the Program based on our
        review of your conduct, Ambassador standing, and any other information
        that we have. Our Customer Support team reviews all requests for
        consideration, and we process these along with all other support
        requests. Please submit any such requests to ambassadors@courselnk.com.
      </p>
      <p class="text">
        This Code of Conduct is considered a living document that we regularly
        update based on the evolution of the CourseLnk Ambassador Program, so
        please review it regularly to keep up with any changes. To the extent
        there is a conflict between this Code of Conduct and any other CourseLnk
        agreements, this document shall govern.
      </p>
      <p class="text">
        As a CourseLnk Ambassador, you will not engage in the following
        behavior:
      </p>
      <p class="text bolded">Non-Disparagement:</p>
      <p class="text bullet1">
        Representing that you are authorized to enter into agreements or take
        actions on behalf of CourseLnk
      </p>
      <p class="text bolded">Non-Disparagement:</p>
      <p class="text bullet1">
        Disparaging CourseLnk, the CourseLnk brand, the app, any CourseLnk
        product, any CourseLnk employee, or Ambassador.
      </p>
      <p class="text bolded">Breaking the Law:</p>
      <p class="text bullet1">
        Violating any applicable provincial (state), national, or international
        laws or regulations either during your participation in the Program or
        relating to your redemption or use of any rewards received through the
        Program.
      </p>
      <p class="text bullet1">
        Engaging in any content or activity that supports, promotes, or offers
        illegal activity.
      </p>
      <p class="text bolded">Cheating/Fraud:</p>
      <p class="text bullet1">
        Misrepresenting your level of success as an Ambassador for rewards
        through any means including using fake accounts.
      </p>
      <p class="text bullet1">Representing yourself as a CourseLnk employee.</p>
      <p class="text bullet1">
        Making any unauthorized statements or purporting to make statements on
        behalf of CourseLnk.
      </p>
      <p class="text bolded">Unauthorized Sharing of Private Information:</p>
      <p class="text bullet1">
        Using personal information of CourseLnk registrants for personal gain or
        benefit.
      </p>
      <p class="text bullet1">
        Disseminating personal information of any CourseLnk user without the
        consent of the user.
      </p>
      <p class="text bullet1">
        Sharing content that may contain personal information about CourseLnk
        users.
      </p>
      <p class="text bullet1">
        Taking or sharing screenshots taken of chats with fellow Ambassadors, or
        CourseLnk employees.
      </p>
      <p class="text bolded">Hateful Conduct:</p>
      <p class="text bullet1">Using foul or inappropriate language.</p>
      <p class="text bullet1">
        Using language, or engaging in any conduct, that directly on indirectly
        promotes, encourages or facilitates discrimination, denigration,
        objectification, harassment, or violence based on any of the following:
      </p>
      <p class="text bullet2">
        Race, national or ethnic origin, colour, religion, age, sex, sexual
        orientation, gender identity or expression, marital status, family
        status, genetic characteristics, disability and conviction for an
        offence for which a pardon has been granted or in respect of which a
        record suspension has been ordered.
      </p>
      <p class="text bullet1">
        Linking to websites containing images or language that promote hateful
        conduct, harassment or discrimination.
      </p>
      <p class="text bullet1">
        Any hateful conduct or language is considered a zero-tolerance violation
        and all Ambassadors engaging in, supporting, or encouraging such conduct
        will be removed from the Program without notice.
      </p>
      <p class="text bolded">Sexual Harassment:</p>
      <p class="text bullet1">
        Harassment is any act, conduct, or content that attempts to intimidate,
        degrade, abuse, or bully others, or creates a hostile environment for
        others. This includes repeated communication to an individual or group
        who has indicated that your communication is not welcome. Depending on
        the severity of the offense, you may be removed from the Program on the
        first violation without notice.
      </p>
      <p class="text bullet1">
        Sexual harassment can occur in many different forms and can be directed
        at any person, regardless of their sex, sexual orientation, gender
        identity or expression. Sexual harassment can include, but is not
        limited to:
      </p>
      <p class="text bullet2">
        Using direct or indirect language, or any other form of communication or
        conduct, that is sexual in nature.
      </p>
      <p class="text bullet2">
        Conduct or content that threatens or promotes sexual violence or
        exploitation is strictly prohibited and may be reported to law
        enforcement.
      </p>
      <p class="text bullet2">
        Linking to websites or images that are sexual in nature or offensive to
        a reasonable person.
      </p>
      <p class="text bullet2">
        Making jokes or comments of a sexual nature toward any person or group.
      </p>
      <p class="text bolded">Violence and Threats of Violence:</p>
      <p class="text bullet1">
        Engaging in violence or attempting or threatening violence. Any such
        behavior will be taken seriously and are considered zero-tolerance
        violations and all Ambassadors associated with such activities will be
        removed from the Program. This includes, but is not limited to:
      </p>
      <p class="text bullet2">
        Referring to violence in any capacity, whether directly or indirectly,
        toward another community member or moderator.
      </p>
      <p class="text bullet2">
        Threatening or attempting violence toward anyone for any reason at any
        time.
      </p>
      <p class="text bolded">
        Bullying, Spamming, Trolling, or Harassment of any kind:
      </p>
      <p class="text bullet1">
        Engaging in any conduct or content that disrupts, interrupts, harms, or
        otherwise violates the integrity of CourseLnk or Ambassador services of
        the Program.
      </p>
      <p class="text bullet1">
        Insulting or defaming another member of the community, CourseLnk or its
        employees, other Ambassadors, or other groups of people.
      </p>
      <p class="text bullet1">Phishing</p>
      <p class="text bullet1">Spreading malware or viruses.</p>
      <p class="text bullet1">Provoking conflict.</p>
      <p class="text bullet1">Making jokes at another person’s expense.</p>
      <p class="text bullet1">
        Engaging in behavior that degrades, demeans, annoys, or otherwise
        negatively disturbs the CourseLnk community.
      </p>
      <p class="text bolded">Advertising</p>
      <p class="text bullet1">
        Advertising any product or service, that is unrelated to CourseLnk
        products.
      </p>
      <p class="text bolded">
        Unauthorized Content Sharing and Other Intellectual Property Violations
      </p>
      <p class="text bullet1">
        Posting or uploading any content that you do not own, do not have the
        rights to, or are otherwise not authorized to use.
      </p>
      <p class="text bolded">Retaliation</p>
      <p class="text bullet1">
        Retaliation for reporting or threatening to report an Ambassador’s
        inappropriate behavior is not permitted.
      </p>
      <p class="text">
        Because this is not an exhaustive list and may not address all manner of
        inappropriate or offensive behavior, CourseLnk reserves the right at
        their full discretion to address behavior deemed inappropriate or
        offensive up to and including removal from the Program. Subject to
        applicable law, CourseLnk is not obligated to provide an Ambassador with
        a reason for any suspension or removal decision.
      </p>
      <p class="text">
        All reports of inappropriate behavior by other Ambassadors or employees
        of CourseLnk should be reported immediately to CourseLnk moderators via
        ambassadors@courselnk.com and not within chats or via direct message.
      </p>
      <p class="text">
        Nothing in this Ambassador Code of Conduct should be interpreted as, or
        purport to, creating an employment relationship between the Ambassador
        and CourseLnk.
      </p>

      <div class="text">
        <input type="checkbox" v-model="conditionCheckbox" />
        <label for="checkbox" style="margin-left: 10px"
          >I have read and accept the code of conductv and the ambassador
          handbook included in the acceptance email*</label
        >
        <div v-if="showConditionError" style="margin-top: 10px; color: red">
          You need to accept the code of conduct before continuing
        </div>
      </div>
      <div class="fixedButton" @click="acceptConditions()">Continue</div>
    </div>
  </div>
</template>

<script>
import db from "@/db";
export default {
  props: ["id"],
  name: "Signup",
  mounted() {
    this.checkID();
  },
  data: () => ({
    ambassadorName: "",
    ambassadorEmail: "",
    isUser: true,
    isChat: false,
    isLink: false,
    notAccepted: true,
    noSocial: true,
    currentPV: 0,
    conditionCheckbox: false,
    userSocialCheckBox: false,
    ourSocialCheckBox: false,
    showConditionError: false,
  }),

  methods: {
    checkID() {
      db.collection("ambassadors")
        .doc(this.id)
        .get()
        .then((doc) => {
          if (!doc.exists) {
            this.$router.push({ name: "Ambassadors" });
          } else {
            console.log("HI  THERE");
            console.log(doc.data().acceptedConditions);
            (this.ambassadorName = doc.data().name),
              (this.ambassadorEmail = doc.data().email);
            this.notAccepted = !doc.data().acceptedConditions;
            this.noSocial = !doc.data().acceptedPersonalSocial;
          }
        });
    },
    changeToUser() {
      this.isUser = true;
      this.isChat = false;
      this.isLink = false;
    },
    changeToChat() {
      this.isUser = false;
      this.isChat = true;
      this.isLink = false;
    },
    changeToLink() {
      this.isUser = false;
      this.isChat = false;
      this.isLink = true;
    },
    acceptConditions() {
      if (this.conditionCheckbox) {
        (this.notAccepted = false), (this.showConditionError = false);
        db.collection("ambassadors")
          .doc(this.id)
          .update({
            acceptedConditions: true,
          });
      } else {
        this.showConditionError = true;
      }
    },
    acceptSocial() {
      if (this.userSocialCheckBox && this.ourSocialCheckBox) {
        (this.noSocial = false), (this.showConditionError = false);
        db.collection("ambassadors")
          .doc(this.id)
          .update({
            acceptedPersonalSocial: true,
            acceptedOurSocial: true,
          });
      } else if (this.userSocialCheckBox) {
        (this.noSocial = false), (this.showConditionError = false);
        db.collection("ambassadors")
          .doc(this.id)
          .update({
            acceptedPersonalSocial: true,
            acceptedOurSocial: false,
          });
      } else {
        this.showConditionError = true;
      }
    },
    changeProgressView(num) {
      this.currentPV = num;
    },
  },
};
//    myPortal/Vsx2MLLKjyWgG42fkAwD
</script>

<style scoped src="@/styles/views/AmbassadorPortal.css"></style>
